(function(){
  var PRODUCTS={
    oversized_standard:{name:'Oversized Standard T-Shirt',fabric:'180 GSM | 100% Super Combed Cotton | Lycra Ribbed Neck | Pre-shrunk',print_areas:'Front, Back, Left Sleeve, Right Sleeve',plain:199,basic:399,premium:599,colors:['White','Black','Navy','Grey','Pink','Lavender','Yellow']},
    oversized_classic:{name:'Oversized Classic T-Shirt',fabric:'240 GSM | Bio-washed Cotton | Pre-shrunk | Double-stitched',print_areas:'Front, Back, Left Sleeve, Right Sleeve',plain:299,basic:499,premium:699,colors:['Black','Dark Navy','Grey','Bottle Green','Navy','Red','Maroon','Purple','Dark Purple','Orange','Dark Teal','Olive','Gold','Pink','Baby Pink','Lavender','Dusty Pink','Mint']},
    terry_oversized:{name:'Terry Oversized T-Shirt',fabric:'260 GSM | French Terry 90% Cotton 10% Polyester',print_areas:'Front, Back, Left Sleeve, Right Sleeve',plain:399,basic:599,premium:799,colors:['Black','Grey','White','Cream']},
    acid_wash_oversized:{name:'Acid Wash Oversized T-Shirt',fabric:'240 GSM | 100% Cotton Acid-washed | Unique per piece',print_areas:'Front, Back, Left Sleeve, Right Sleeve',plain:499,basic:699,premium:899,colors:['Black','Grey','Blue','Green']},
    tie_dye_oversized:{name:'Tie Dye Oversized T-Shirt',fabric:'260 GSM | 90% Cotton 10% Polyester | Handmade Tie-Dye',print_areas:'Front, Back, Left Sleeve, Right Sleeve',plain:699,basic:899,premium:999,colors:['Yellow','Black','Teal','Brown','Lavender']},
    classic_tshirt:{name:'Classic T-Shirt',fabric:'180 GSM | 100% Super Combed Cotton Bio-washed | Double-stitched',print_areas:'Front, Back, Left Sleeve, Right Sleeve',plain:299,basic:499,premium:599,colors:['Black','White','Navy','Grey','Maroon','Red']},
    standard_tshirt:{name:'Standard T-Shirt',fabric:'180 GSM | 100% Cotton Lycra Ribbed Neck | Pre-shrunk',print_areas:'Front, Back, Left Sleeve, Right Sleeve',plain:249,basic:449,premium:549,colors:['Black','White','Navy','Grey']},
    vneck_tshirt:{name:'V-Neck T-Shirt',fabric:'180 GSM | 100% Cotton V-Neck Collar | Pre-shrunk',print_areas:'Front, Back, Left Sleeve, Right Sleeve',plain:299,basic:499,premium:599,colors:['White','Black','Navy','Grey','Maroon','Navy Blue','Red']},
    cotton_stretch:{name:'Cotton Stretch T-Shirt',fabric:'240 GSM | 95% Cotton 5% Elastane | Bio-washed | 4-way Stretch',print_areas:'Front, Back, Left Sleeve, Right Sleeve',plain:449,basic:649,premium:749,colors:['White','Black','Navy','Maroon','Pink','Lavender','Mint','Sky Blue']},
    raglan_fullsleeve:{name:'Raglan Full Sleeve T-Shirt',fabric:'220 GSM | Cotton Blend Contrast Raglan Sleeves',print_areas:'Front, Back, Left Sleeve, Right Sleeve',plain:399,basic:599,premium:699,colors:['Black/White','Navy/White','Maroon/White','Grey/Black']},
    male_sleeveless:{name:'Male Sleeveless T-Shirt',fabric:'180 GSM | 100% Cotton Ribbed Neck | Regular Fit',print_areas:'Front, Back',plain:249,basic:449,premium:549,colors:['Black','White','Navy','Grey']},
    unisex_ringer:{name:'Unisex Ringer T-Shirt',fabric:'180 GSM | 100% Cotton Bio-washed | Ribbed Neck | Contrast Trims',print_areas:'Front, Back, Left Sleeve, Right Sleeve',plain:399,basic:599,premium:799,colors:['Black/Tan','White/Orange','Maroon/Tan','Navy/Dark']},
    oversized_shirt:{name:'Oversized Shirt',fabric:'240 GSM | 100% Premium Cotton | Half Sleeves | Straight Hem | Button Placket',print_areas:'Front, Back, Left Sleeve, Right Sleeve',plain:399,basic:599,premium:799,colors:['White','Black','Navy','Pink','Maroon','Sky Blue','Lavender','Beige','Mauve']},
    polo_tshirt:{name:'Polo T-Shirt',fabric:'220 GSM | Airtex Fabric | Collared Neck | Semi-formal | Cuff Hem | Bio-washed',print_areas:'Front, Back, Left Sleeve, Right Sleeve',plain:399,basic:599,premium:799,colors:['Black','Navy','Grey','Dark Navy','Maroon','Purple','Teal','Red','Gold']}
  };

  var COLOR_HEX={White:'#f5f5f5',Black:'#111',Navy:'#1a2a4a',Grey:'#888',Pink:'#f4b8c8',Lavender:'#c8b8f4',Yellow:'#f4e258','Dark Navy':'#0d1a2e','Bottle Green':'#1a4a2e',Red:'#c0392b',Maroon:'#800000',Purple:'#6a0dad','Dark Purple':'#3a0060',Orange:'#e67e22','Dark Teal':'#0d4a4a',Olive:'#6b7c3a',Gold:'#c9a84c','Baby Pink':'#ffd6e0','Dusty Pink':'#d4a0a0',Mint:'#b5ead7','Sky Blue':'#87ceeb',Blue:'#2980b9',Green:'#27ae60',Cream:'#fffdd0',Brown:'#7b4f2e',Teal:'#008080',Beige:'#f5f0dc',Mauve:'#b08080','Navy Blue':'#000080'};

  var EMB={front_chest:599,back:599,left_sleeve:499,right_sleeve:499};
  var EMB_LABELS={front_chest:'Front Chest',back:'Back',left_sleeve:'Left Sleeve',right_sleeve:'Right Sleeve'};
  var selProduct=null,selPrint=null,selEmb={};
  var scOpen=false;
  var pinTimer=null;

  var btn=document.getElementById('vn_pay_btn');
  var RZP_KEY=btn.getAttribute('data-rzp');
  var EJS_SVC=btn.getAttribute('data-ejs-svc');
  var EJS_TPL=btn.getAttribute('data-ejs-tpl');
  var EJS_PUB=btn.getAttribute('data-ejs-pub');

  var rzpScript=document.createElement('script');
  rzpScript.src='https://checkout.razorpay.com/v1/checkout.js';
  document.head.appendChild(rzpScript);
  var ejsScript=document.createElement('script');
  ejsScript.src='https://cdn.jsdelivr.net/npm/@emailjs/browser@4/dist/email.min.js';
  ejsScript.onload=function(){if(EJS_PUB)emailjs.init(EJS_PUB);};
  document.head.appendChild(ejsScript);

  // ── Pincode Lookup ───────────────────────────────────────────
  window.vnLookupPin=function(val){
    clearTimeout(pinTimer);
    var statusEl=document.getElementById('vn_pin_status');
    if(val.length!==6){statusEl.textContent='';return;}
    statusEl.textContent='Looking up...';
    statusEl.style.color='#aaa';
    pinTimer=setTimeout(function(){
      fetch('https://api.postalpincode.in/pincode/'+val)
        .then(function(r){return r.json();})
        .then(function(data){
          if(data&&data[0]&&data[0].Status==='Success'&&data[0].PostOffice&&data[0].PostOffice.length>0){
            var po=data[0].PostOffice[0];
            var cityEl=document.getElementById('vn_addr_city');
            var stateEl=document.getElementById('vn_addr_state');
            if(!cityEl.value.trim()) cityEl.value=po.District||po.Name||'';
            var stateMap={
              'uttaranchal':'Uttarakhand','uttarakhand':'Uttarakhand',
              'orissa':'Odisha','odisha':'Odisha',
              'pondicherry':'Puducherry','puducherry':'Puducherry',
              'jammu and kashmir':'Jammu & Kashmir','jammu & kashmir':'Jammu & Kashmir',
              'andaman and nicobar':'Andaman and Nicobar Islands',
              'dadra and nagar haveli':'Dadra and Nagar Haveli and Daman and Diu',
              'daman and diu':'Dadra and Nagar Haveli and Daman and Diu',
              'dadra and nagar haveli and daman and diu':'Dadra and Nagar Haveli and Daman and Diu',
              'delhi':'Delhi','new delhi':'Delhi'
            };
            var apiState=(po.State||'').trim();
            var normalized=stateMap[apiState.toLowerCase()]||apiState;
            var opts=stateEl.options;
            var matched=false;
            for(var i=0;i<opts.length;i++){
              if(opts[i].text.toLowerCase()===normalized.toLowerCase()){stateEl.value=opts[i].text;matched=true;break;}
            }
            if(!matched){
              for(var j=0;j<opts.length;j++){
                if(opts[j].text.toLowerCase().indexOf(normalized.toLowerCase())>-1){stateEl.value=opts[j].text;break;}
              }
            }
            statusEl.textContent='✓ '+po.District+', '+normalized;
            statusEl.style.color='#27ae60';
            document.getElementById('err_addr_pincode').textContent='';
          } else {
            statusEl.textContent='Pincode not found — fill manually';
            statusEl.style.color='#e74c3c';
          }
        })
        .catch(function(){
          statusEl.textContent='Lookup failed — fill manually';
          statusEl.style.color='#e74c3c';
        });
    },600);
  };

  function getFullAddress(){
    var l1=document.getElementById('vn_addr_line1').value.trim();
    var l2=document.getElementById('vn_addr_line2').value.trim();
    var city=document.getElementById('vn_addr_city').value.trim();
    var pin=document.getElementById('vn_addr_pincode').value.trim();
    var state=document.getElementById('vn_addr_state').value;
    return l1+(l2?', '+l2:'')+', '+city+' - '+pin+', '+state+', India';
  }

  // ── Steps ────────────────────────────────────────────────────
  function setStep(n){
    document.getElementById('vnStep1').style.display=n===1?'block':'none';
    document.getElementById('vnStep2').style.display=n===2?'block':'none';
    document.getElementById('vnStep3').style.display=n===3?'block':'none';
    [1,2,3].forEach(function(i){
      var el=document.getElementById('stp'+i);
      el.classList.toggle('active',i===n);
      el.classList.toggle('done',i<n);
    });
    setTimeout(function(){
      var stepper=document.getElementById('stp1');
      if(stepper) stepper.scrollIntoView({behavior:'smooth',block:'start'});
    },50);
  }

  window.vnGoStep1=function(){setStep(1);};
  window.vnGoStep2=function(){if(!validateStep1())return;setStep(2);};
  window.vnGoStep3=function(){if(!validateStep2())return;buildReview();vnCalcTotal();setStep(3);};

  window.vnUpdateProduct=function(){
    var k=document.getElementById('vn_product').value;
    selProduct=PRODUCTS[k]||null;
    selPrint=null;selEmb={};
    document.getElementById('vn_print_val').value='';
    document.querySelectorAll('.vn-print-card').forEach(function(c){c.classList.remove('active');});
    document.getElementById('vn_print_areas_wrap').style.display='none';
    document.getElementById('vn_design_links_wrap').style.display='none';
    document.getElementById('vn_link_fields').innerHTML='';
    document.getElementById('vn_emb_placement_wrap').style.display='none';
    document.querySelectorAll('.vn-emb-card').forEach(function(c){c.classList.remove('active');});
    document.querySelectorAll('input[name="print_area"]').forEach(function(c){c.checked=false;c.disabled=false;});
    document.getElementById('vn_size_chart_wrap').style.display='none';
    document.getElementById('vn_size_chart_img_wrap').style.display='none';
    document.getElementById('vn_sc_toggle_text').textContent='View Size Chart ↓';
    document.getElementById('vn_total_display').textContent='—';
    document.getElementById('row_product').style.display='none';
    document.getElementById('row_emb').style.display='none';
    scOpen=false;
    if(!selProduct){
      document.getElementById('vn_product_info').style.display='none';
      document.getElementById('vn_color_wrap').style.display='none';
      document.getElementById('vn_size_qty_wrap').style.display='none';
      return;
    }
    document.getElementById('vn_fabric').textContent=selProduct.fabric;
    document.getElementById('vn_print_areas_info').textContent='Available Print Areas: '+selProduct.print_areas;
    document.getElementById('vn_product_info').style.display='block';
    document.getElementById('pp_plain').textContent='Rs.'+selProduct.plain;
    document.getElementById('pp_basic').textContent='Rs.'+selProduct.basic;
    document.getElementById('pp_premium').textContent='Rs.'+selProduct.premium;
    var grid=document.getElementById('vn_color_grid');
    grid.innerHTML='';
    selProduct.colors.forEach(function(c){
      var parts=c.split('/');
      var bg=parts.length>1?'linear-gradient(135deg,'+(COLOR_HEX[parts[0]]||'#555')+' 50%,'+(COLOR_HEX[parts[1]]||'#888')+' 50%)':(COLOR_HEX[c]||'#555');
      var item=document.createElement('div');item.className='vn-color-item';
      var dot=document.createElement('div');dot.className='vn-color-dot';dot.style.background=bg;dot.title=c;
      dot.onclick=function(){
        document.querySelectorAll('.vn-color-dot').forEach(function(d){d.classList.remove('selected');});
        dot.classList.add('selected');
        document.getElementById('vn_color_val').value=c;
        document.getElementById('err_color').textContent='';
      };
      var lbl=document.createElement('span');lbl.className='vn-color-name';lbl.textContent=c;
      item.appendChild(dot);item.appendChild(lbl);grid.appendChild(item);
    });
    document.getElementById('vn_color_val').value='';
    document.getElementById('vn_color_wrap').style.display='block';
    document.getElementById('vn_size_qty_wrap').style.display='grid';
    var scUrl=window.VN_SIZE_CHARTS&&window.VN_SIZE_CHARTS[k]?window.VN_SIZE_CHARTS[k]:'';
    if(scUrl&&scUrl.indexOf('no-image')===-1&&scUrl.length>10){
      document.getElementById('vn_size_chart_img').src=scUrl;
      document.getElementById('vn_size_chart_wrap').style.display='block';
    }
  };

  window.vnToggleSizeChart=function(){
    scOpen=!scOpen;
    document.getElementById('vn_size_chart_img_wrap').style.display=scOpen?'block':'none';
    document.getElementById('vn_sc_toggle_text').textContent=scOpen?'Hide Size Chart ↑':'View Size Chart ↓';
  };

  function makeLinkField(label,key){
    var id='vn_link_'+key;
    return '<div style="margin-bottom:24px">'+
      '<label for="'+id+'" style="display:block;font-size:10px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#888;margin-bottom:8px">'+label+' — Design Link *</label>'+
      '<input type="url" id="'+id+'" data-area="'+label+'" placeholder="Paste your Google Drive / Dropbox shareable link here" '+
      'style="background:#f7f7f7;color:#111;-webkit-text-fill-color:#111;border:1px solid #ddd;padding:14px 16px;font-size:15px;border-radius:4px;width:100%;box-sizing:border-box;font-family:inherit;outline:none;transition:border-color .2s;" '+
      'onfocus="this.style.borderColor=\'#111\';this.style.boxShadow=\'0 0 0 1px #111\'" '+
      'onblur="this.style.borderColor=\'#ddd\';this.style.boxShadow=\'none\'">'+
      '<div style="font-size:12px;color:#666;margin-top:8px;line-height:1.7;padding:10px 12px;background:#f0f0f0;border-radius:4px;">'+
      '📎 <strong>How to share your design:</strong><br>'+
      '1. Upload to <a href="https://drive.google.com" target="_blank" style="color:#111;font-weight:700;">Google Drive</a> or <a href="https://www.dropbox.com" target="_blank" style="color:#111;font-weight:700;">Dropbox</a><br>'+
      '2. Right-click → <strong>Get shareable link</strong> → <strong>"Anyone with link"</strong><br>'+
      '3. Paste that link above for <strong>'+label+'</strong></div>'+
      '<span class="vn-error" id="err_'+id+'" style="color:#e74c3c;font-size:11px;min-height:16px;display:block;margin-top:4px"></span>'+
    '</div>';
  }

  window.vnSelectPrint=function(type){
    selPrint=type;selEmb={};
    document.getElementById('vn_print_val').value=type;
    document.querySelectorAll('.vn-print-card').forEach(function(c){
      c.classList.toggle('active',c.getAttribute('data-print')===type);
    });
    document.getElementById('err_print_type').textContent='';
    document.querySelectorAll('input[name="print_area"]').forEach(function(c){c.checked=false;c.disabled=false;});
    document.getElementById('err_print').textContent='';
    document.getElementById('vn_link_fields').innerHTML='';
    document.getElementById('vn_design_links_wrap').style.display='none';
    document.getElementById('vn_print_areas_wrap').style.display='none';
    document.getElementById('vn_emb_placement_wrap').style.display='none';
    document.querySelectorAll('.vn-emb-card').forEach(function(c){c.classList.remove('active');});
    document.getElementById('err_emb_placement').textContent='';
    document.getElementById('row_emb').style.display='none';
    if(type==='plain'){
    } else if(type==='basic'){
      document.getElementById('vn_print_areas_wrap').style.display='block';
      document.querySelectorAll('input[name="print_area"]').forEach(function(c){
        if(c.value==='Front'){c.checked=true;}else{c.disabled=true;}
      });
      vnUpdateLinkFields();
    } else if(type==='premium'){
      document.getElementById('vn_print_areas_wrap').style.display='block';
    } else if(type==='embroidery'){
      document.getElementById('vn_emb_placement_wrap').style.display='block';
    }
    vnCalcTotal();
  };

  window.vnUpdateLinkFields=function(){
    if(!selPrint||selPrint==='plain'||selPrint==='embroidery') return;
    var areas=[];
    if(selPrint==='basic'){
      areas=[{label:'Front',key:'front'}];
    } else {
      document.querySelectorAll('input[name="print_area"]:checked').forEach(function(c){
        areas.push({label:c.value,key:c.value.replace(/\s+/g,'_').toLowerCase()});
      });
    }
    if(areas.length===0){
      document.getElementById('vn_design_links_wrap').style.display='none';
      document.getElementById('vn_link_fields').innerHTML='';
      return;
    }
    var html='';
    areas.forEach(function(a){html+=makeLinkField(a.label,a.key);});
    document.getElementById('vn_link_fields').innerHTML=html;
    document.getElementById('vn_design_links_wrap').style.display='block';
  };

  function vnUpdateEmbLinks(){
    var keys=Object.keys(selEmb);
    if(keys.length===0){
      document.getElementById('vn_design_links_wrap').style.display='none';
      document.getElementById('vn_link_fields').innerHTML='';
      return;
    }
    var html='';
    keys.forEach(function(k){html+=makeLinkField(EMB_LABELS[k],k);});
    document.getElementById('vn_link_fields').innerHTML=html;
    document.getElementById('vn_design_links_wrap').style.display='block';
  }

  document.querySelectorAll('input[name="print_area"]').forEach(function(cb){
    cb.addEventListener('change',function(){if(selPrint==='premium') vnUpdateLinkFields();});
  });

  window.vnToggleEmbPlacement=function(key,el){
    if(selEmb[key]){delete selEmb[key];el.classList.remove('active');}
    else{selEmb[key]=EMB[key];el.classList.add('active');}
    vnUpdateEmbLinks();
    vnCalcTotal();
  };

  window.vnCalcTotal=function(){
    if(!selProduct||!selPrint){document.getElementById('vn_total_display').textContent='—';return 0;}
    var qty=parseInt(document.getElementById('vn_qty').value)||1;
    var base=0,emb=0;
    if(selPrint==='embroidery'){
      base=selProduct.plain;
      emb=Object.values(selEmb).reduce(function(a,b){return a+b;},0);
    } else {
      base=selProduct[selPrint]||0;
    }
    var total=(base*qty)+(emb*qty)+200;
    var pnames={plain:'Plain',basic:'Basic Print',premium:'Premium Print',embroidery:'Embroidery'};
    document.getElementById('lbl_product').textContent=selProduct.name+' x'+qty+' ('+pnames[selPrint]+')';
    document.getElementById('val_product').textContent='Rs.'+(base*qty);
    document.getElementById('row_product').style.display='flex';
    if(emb>0){
      document.getElementById('val_emb').textContent='Rs.'+(emb*qty);
      document.getElementById('row_emb').style.display='flex';
    } else {
      document.getElementById('row_emb').style.display='none';
    }
    document.getElementById('vn_total_display').textContent='Rs.'+total;
    return total;
  };

  function getLinksData(){
    var result={};
    document.querySelectorAll('#vn_link_fields input[type="url"]').forEach(function(inp){
      result[inp.getAttribute('data-area')]=inp.value||'Not provided';
    });
    return result;
  }

  function getLinksSummary(){
    var parts=[];
    var data=getLinksData();
    Object.keys(data).forEach(function(a){parts.push(a+': '+data[a]);});
    return parts.join(' | ')||'N/A';
  }

  function getEmbSummary(){
    if(!Object.keys(selEmb).length) return 'None';
    var pm={front_chest:'Rs.599',back:'Rs.599',left_sleeve:'Rs.499',right_sleeve:'Rs.499'};
    return Object.keys(selEmb).map(function(k){return EMB_LABELS[k]+' ('+pm[k]+')';}).join(', ');
  }

  function buildReview(){
    var pnames={plain:'Plain',basic:'Basic Print (Front Only)',premium:'Premium Print',embroidery:'Embroidery'};
    var printAreas=(selPrint==='plain'||selPrint==='embroidery')?'N/A':
      Array.from(document.querySelectorAll('input[name="print_area"]:checked')).map(function(c){return c.value;}).join(', ')||'N/A';
    var rows=[
      ['Product',selProduct?selProduct.name:'—'],
      ['Color',document.getElementById('vn_color_val').value||'—'],
      ['Size',document.getElementById('vn_size').value],
      ['Quantity',document.getElementById('vn_qty').value],
      ['Print Type',selPrint?pnames[selPrint]:'—'],
      ['Print Areas',printAreas],
      ['Design Links',getLinksSummary()],
      ['Embroidery',selPrint==='embroidery'?getEmbSummary():'None'],
      ['Font',document.getElementById('vn_font').value||'Not specified'],
      ['Notes',document.getElementById('vn_notes').value||'None'],
      ['',''],
      ['Name',document.getElementById('vn_name').value],
      ['Phone','+91 '+document.getElementById('vn_phone').value],
      ['Email',document.getElementById('vn_email').value],
      ['Address',getFullAddress()]
    ];
    var html='';
    rows.forEach(function(r){
      if(r[0]===''){html+='<div class="vn-review-divider"></div>';return;}
      html+='<div class="vn-review-row"><span class="vn-review-label">'+r[0]+'</span><span class="vn-review-val">'+r[1]+'</span></div>';
    });
    document.getElementById('vn_review_box').innerHTML=html;
  }

  function validateStep1(){
    var ok=true;
    if(!document.getElementById('vn_product').value){document.getElementById('err_product').textContent='Select a product';ok=false;}else{document.getElementById('err_product').textContent='';}
    if(!document.getElementById('vn_color_val').value){document.getElementById('err_color').textContent='Select a color';ok=false;}else{document.getElementById('err_color').textContent='';}
    if(!document.getElementById('vn_size').value){document.getElementById('err_size').textContent='Select size';ok=false;}else{document.getElementById('err_size').textContent='';}
    if(!document.getElementById('vn_qty').value||parseInt(document.getElementById('vn_qty').value)<1){document.getElementById('err_qty').textContent='Enter valid quantity';ok=false;}else{document.getElementById('err_qty').textContent='';}
    if(!document.getElementById('vn_print_val').value){document.getElementById('err_print_type').textContent='Select print type';ok=false;}else{document.getElementById('err_print_type').textContent='';}
    if(selPrint==='basic'||selPrint==='premium'){
      var pc=document.querySelectorAll('input[name="print_area"]:checked');
      if(pc.length===0){document.getElementById('err_print').textContent='Select at least one print area';ok=false;}else{document.getElementById('err_print').textContent='';}
    }
    if(selPrint==='embroidery'){
      if(!Object.keys(selEmb).length){document.getElementById('err_emb_placement').textContent='Select at least one embroidery placement';ok=false;}
      else{document.getElementById('err_emb_placement').textContent='';}
    }
    document.querySelectorAll('#vn_link_fields input[type="url"]').forEach(function(inp){
      var errEl=document.getElementById('err_'+inp.id);
      if(!inp.value.trim()){if(errEl)errEl.textContent=inp.getAttribute('data-area')+' design link is required';ok=false;}
      else{if(errEl)errEl.textContent='';}
    });
    if(!ok){var e=document.querySelector('.vn-error:not(:empty)');if(e)e.scrollIntoView({behavior:'smooth',block:'center'});}
    return ok;
  }

  function validateStep2(){
    var ok=true;
    function chk(id,eid,msg){if(!document.getElementById(id).value.trim()){document.getElementById(eid).textContent=msg;ok=false;}else{document.getElementById(eid).textContent='';}}
    chk('vn_name','err_name','Name required');
    var ph=document.getElementById('vn_phone').value.replace(/[^0-9]/g,'');
    if(ph.length!==10){document.getElementById('err_phone').textContent='Enter valid 10 digit number';ok=false;}else{document.getElementById('err_phone').textContent='';}
    chk('vn_email','err_email','Email required');
    chk('vn_addr_line1','err_addr_line1','House/Flat details required');
    chk('vn_addr_city','err_addr_city','City required');
    var pin=document.getElementById('vn_addr_pincode').value.replace(/[^0-9]/g,'');
    if(pin.length!==6){document.getElementById('err_addr_pincode').textContent='Enter valid 6 digit pincode';ok=false;}else{document.getElementById('err_addr_pincode').textContent='';}
    if(!document.getElementById('vn_addr_state').value){document.getElementById('err_addr_state').textContent='Select state';ok=false;}else{document.getElementById('err_addr_state').textContent='';}
    if(!ok){var e=document.querySelector('.vn-error:not(:empty)');if(e)e.scrollIntoView({behavior:'smooth',block:'center'});}
    return ok;
  }

  btn.addEventListener('click',function(){
    var total=vnCalcTotal();
    var rid='VMNOIR-'+Date.now();
    var pnames={plain:'Plain',basic:'Basic Print (Front Only)',premium:'Premium Print',embroidery:'Embroidery'};
    var printAreas=(selPrint==='plain'||selPrint==='embroidery')?'N/A':
      Array.from(document.querySelectorAll('input[name="print_area"]:checked')).map(function(c){return c.value;}).join(', ')||'N/A';
    var phone='+91'+document.getElementById('vn_phone').value;
    var opts={
      key:RZP_KEY,amount:total*100,currency:'INR',
      name:'VM NOIR',description:selProduct.name,receipt:rid,
      prefill:{name:document.getElementById('vn_name').value,email:document.getElementById('vn_email').value,contact:phone},
      theme:{color:'#111111'},
      handler:function(resp){
        var p={
          customer_name:document.getElementById('vn_name').value,
          phone:phone,email:document.getElementById('vn_email').value,
          product:selProduct.name,color:document.getElementById('vn_color_val').value,
          size:document.getElementById('vn_size').value,quantity:document.getElementById('vn_qty').value,
          print_type:pnames[selPrint],print_areas:printAreas,
          design_links:getLinksSummary(),
          embroidery:selPrint==='embroidery'?getEmbSummary():'None',
          font_style:document.getElementById('vn_font').value||'Not specified',
          delivery_address:getFullAddress(),
          special_instructions:document.getElementById('vn_notes').value||'None',
          payment_id:resp.razorpay_payment_id,receipt_id:rid,
          total_amount:'Rs.'+total,timestamp:new Date().toLocaleString('en-IN')
        };
        if(EJS_SVC&&EJS_TPL)emailjs.send(EJS_SVC,EJS_TPL,p);
        document.getElementById('vnStep3').style.display='none';
        document.getElementById('vn_success').style.display='flex';
        document.getElementById('vn_success_details').innerHTML=
          '<p><strong>Payment ID:</strong> '+p.payment_id+'</p>'+
          '<p><strong>Product:</strong> '+p.product+'</p>'+
          '<p><strong>Color:</strong> '+p.color+'</p>'+
          '<p><strong>Size:</strong> '+p.size+' x'+p.quantity+'</p>'+
          '<p><strong>Print Type:</strong> '+p.print_type+'</p>'+
          '<p><strong>Design Links:</strong> '+p.design_links+'</p>'+
          '<p><strong>Embroidery:</strong> '+p.embroidery+'</p>'+
          '<p><strong>Address:</strong> '+p.delivery_address+'</p>'+
          '<p><strong>Total Paid:</strong> '+p.total_amount+'</p>'+
          '<p><strong>Receipt:</strong> '+rid+'</p>';
      }
    };
    new Razorpay(opts).open();
  });
})();
